import { Button } from 'components/Button';
import { Modal } from 'components/modal/Modal';
import React, { Fragment } from 'react';
import './ModalValidityPeriod.scss';
import { toFormattedDate } from 'components/DateTime';
/**
 * @component ModalValidityPeriod
 * @since 1.0.0
 * @hidden
 */
export function ModalValidityPeriod(props) {
    const { deal, validityPeriodDate, onClose } = props;
    /**
     * @function onModalFooterAction
     * @since 1.0.0
     * @hidden
     */
    function onModalFooterAction(openChat) {
        if (openChat) {
            props.onDiscuss();
        }
        onClose();
    }
    const footerActions = (React.createElement(Fragment, null,
        React.createElement(Button, { style: "primary", label: t('View Quote') + ' #' + (deal === null || deal === void 0 ? void 0 : deal.number), onPress: () => onModalFooterAction(false) })));
    return (React.createElement("div", { className: "modal-validity-period" },
        React.createElement(Modal, { picto: "warning", title: t('IMPORTANT'), onClose: onClose, showFooterAction: true, footerActions: footerActions },
            React.createElement("div", { className: "modal-validity-period-content" },
                React.createElement("div", { className: "modal-validity-period-content__text" },
                    React.createElement("strong", null,
                        React.createElement("p", null,
                            t('The validity period for Quote'),
                            " ",
                            '#' + (deal === null || deal === void 0 ? void 0 : deal.number),
                            ' ',
                            t('has expired as of'),
                            ' ',
                            toFormattedDate(validityPeriodDate !== null && validityPeriodDate !== void 0 ? validityPeriodDate : '', {
                                y: 'numeric',
                                m: 'numeric',
                                d: 'numeric'
                            }),
                            ".")),
                    React.createElement("br", null),
                    React.createElement("br", null),
                    React.createElement("p", null, t('You can continue to view and interact with this quote; however, please be aware that it is no longer guaranteed and may require adjustments by your assigned representative.')))))));
}
